import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import energy_category from '@devices/settings/device_settings/energy_category.js';

export default {
	name: 'ShellyEMMiniG4',
	friendly_name: 'EM Mini Gen 4',
	family: 'emeter',
	isPM: true,
	gen: 2,
	modes: {
		emeter: {
			availableViews: ['basic'],
			channels: 1,
			phases: 1,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				webhooks_gen_2,
				virtual_components,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'application_settings',
					components: [
						{ title: 'ai_model', component: 'ai_model' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						energy_category,
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'emeter_measurement', component: 'emeter_measurement' },
						{
							title: 'reverse_measurement_direction',
							component: 'reverse_measurement_direction_monophase',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'emeter_stored_data', component: 'emeter_stored_data' },
						{ title: 'delete_stored_data', component: 'delete_stored_data_g2' },
						{
							title: 'reset_energy_counters',
							component: 'reset_energy_counters_g2',
							min_ver: '1.2.0',
						},
						{ title: 'emeter_alarms', component: 'emeter_alarms', min_ver: '2.0.0' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
